import React from "react";
import { Alert, Text, Title } from "@gjensidige/builders-components";

const Receipt = () => (
  <Alert severity="success" tracking={{eventLabel: 'tak-for-din-henvendelse'}} style={{ whiteSpace: "pre-line" }}>
    <Title>Tak for din henvendelse</Title>
    <Text>
      {`Vi kontakter dig inden for 48 timer med et uforpligtende tilbud.

          Vi glæder os til at tale med dig!`}
    </Text>
  </Alert>
);

export default Receipt;
